/**
 * Terme imprimé sur les tickets (PDF et imprimante) devant le numéro de bipeur.
 * Paramétré par section (section.advanceparams.bipeur_label : 'bipeur' | 'table'),
 * 'bipeur' par défaut quand le paramètre est absent.
 *
 * @param {Object|false} section - La section du ticket (peut être false/undefined)
 * @returns {string} 'TABLE' ou 'BIPEUR'
 */
export const bipeurTicketLabel = (section) => section?.advanceparams?.bipeur_label === 'table' ? 'TABLE' : 'BIPEUR'
